import { render, staticRenderFns } from "./WaitingList-Edit.vue?vue&type=template&id=2cdc9e68&"
import script from "./WaitingList-Edit.js?vue&type=script&lang=js&"
export * from "./WaitingList-Edit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports